import React from "react";
import Hackathons from "../components/Hackathons/Hackathons";

function HackathonPage() {
  return (
    <div>
      <Hackathons />
    </div>
  );
}

export default HackathonPage;
